import React, { useState } from "react";
import CenteredHeading from "../../../../components/UI/headingsUI/CenteredHeading";
import FormTabSwitcher from "../../../../components/UI/FormTabSwitcher";
import AddSingleSiteForm from "./AddSIngleSiteForm";
import AddBulkSite from "./AddBulkSite";

const tabs = [
  { name: "single", label: "Add Single Site" },
  { name: "bulk", label: "Add Bulk Site" },
];

const SiteTabsContainer = ({ siteSetup }) => {
  const [currentTab, setCurrentTab] = useState("single");

  return (
    <div className="form-container">
      <CenteredHeading title="Add Site" />
      <div className="cylinder-tab-container">
        <FormTabSwitcher
          tabs={tabs}
          currentTab={currentTab}
          onTabChange={(tabName) => setCurrentTab(tabName)}
        />
        <div className="p-1 sm:p-4">
          {currentTab === "single" && (
            <AddSingleSiteForm siteSetup={siteSetup} />
          )}
          {currentTab === "bulk" && <AddBulkSite />}
        </div>
      </div>
    </div>
  );
};

export default SiteTabsContainer;
